import { StyledFormControl } from 'components/AdminConsole/commonUI/styles'
import { PreviewAvatarsList } from 'components/CommonComponents/PreviewList'
import { User } from 'lucide-react'
import { Box, FormErrorMessage } from '@chakra-ui/core'
import React, { useMemo } from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import UsersList from 'components/CommonComponents/UsersList'
import useLocaleText from 'components/useLocaleText'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { SelectionMode } from 'components/CommonComponents/OptimizedGroupsTree/hooks/useSelection'

export const RePopRecipient = ({ isCustomAvatar }: { isCustomAvatar: boolean }) => {
  const { control, watch, setValue, clearError, getValues, errors } = useFormContext()
  const { retailUsersObject } = useSelector((state: RootState) => state.config.config)
  const t_user = useLocaleText('t_user', true)

  const watchedUsers = (watch('users') as string[]) || []
  const selectedUsersIds = useMemo(() => watchedUsers || [], [watchedUsers])

  const popUsers = useMemo(() => {
    return selectedUsersIds.map((id: string) => retailUsersObject?.[id])
  }, [retailUsersObject, selectedUsersIds])

  const validateAudience = () => {
    const users = (getValues('users') as string[]) || []
    const hasUsers = users.length > 0

    if (!hasUsers) {
      return 'A user must be selected'
    }

    return true
  }

  const handleUsersSelectionChange = (ids: string[]) => {
    setValue('users', ids as string[], true)
    clearError(['users'])

    if (!isCustomAvatar) {
      const user = retailUsersObject?.[ids[0]]
      const userProfileImage = user?.avatar_profile_img_url || user?.profile_img_url
      setValue('data.profile_image_url', userProfileImage, true)
    }
  }

  const listHeight = 300

  const hasAudienceError = errors['users']

  return (
    <StyledFormControl>
      <StyledFormControl>
        <PreviewAvatarsList
          icon={User}
          label={t_user}
          items={popUsers.map((user) => ({
            name: `${user?.first_name} ${user?.last_name || ''}`,
            profile_img_url: user?.profile_img_url,
          }))}
          defaultValue="-"
          max={10}
        />
      </StyledFormControl>

      <Box
        borderRadius="5px"
        padding={{ base: '0px', md: '10px' }}
        mt={2}
        bg="white"
        border={hasAudienceError ? '1px solid red' : '1px solid #e0e0e0'}
        boxShadow={hasAudienceError ? '0px 0px 0px 1px red' : 'none'}
      >
        <Controller
          control={control}
          name="users"
          defaultValue={selectedUsersIds}
          rules={{
            validate: validateAudience,
          }}
          as={
            <UsersList
              showSearch
              listHeight={listHeight}
              initialSelectedIds={selectedUsersIds}
              selectionMode={SelectionMode.SINGLE}
              onSelectionChange={handleUsersSelectionChange}
            />
          }
        />
      </Box>

      <StyledFormControl isInvalid={!!hasAudienceError}>
        <FormErrorMessage>{(errors['users'] as any)?.message}</FormErrorMessage>
      </StyledFormControl>
    </StyledFormControl>
  )
}
